import * as fromDatatype from '../datatype-library/index'


export interface bl_mrp_prodsys_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    mrp_hdr_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    column: fromDatatype.VarcharDatatypeInterface;
    prodsysHdr1Guid: fromDatatype.GuidDataFieldInterface;
    prodsysHdr2Guid: fromDatatype.GuidDataFieldInterface;
    prodsysLine1Guid: fromDatatype.GuidDataFieldInterface;
    prodsysLine2Guid: fromDatatype.GuidDataFieldInterface;
  };


export class bl_mrp_prodsys_line_RowClass implements bl_mrp_prodsys_line_RowInterface
  {
    guid: fromDatatype.GuidDataFieldInterface;
    mrp_hdr_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    column: fromDatatype.VarcharDatatypeInterface;
    prodsysHdr1Guid: fromDatatype.GuidDataFieldInterface;
    prodsysHdr2Guid: fromDatatype.GuidDataFieldInterface;
    prodsysLine1Guid: fromDatatype.GuidDataFieldInterface;
    prodsysLine2Guid: fromDatatype.GuidDataFieldInterface;
  }